<template>
    <div id="app" class="full-height">
        <navbar v-if="user" :user="user"></navbar>
        <router-view :user="user" :api="api"></router-view>
        <foot v-if="user"></foot>
    </div>
</template>

<script type="text/babel">
import Head from './components/commons/Header'
import Foot from './components/commons/Footer'

export default {
    name: 'app',
    components: {
        "navbar": Head,
        Foot
    },
    data() {
        return {
            api: api_routes,
            user: $auth.getUser()
        }
    },

    methods: {
        guard() {
            let access_token = window.location.hash.match(/[?#]access_token=([^&]*)?/);
            access_token = ( access_token == null ? "" : access_token[1] || "" );

            if (access_token && !$auth.checkAuth()) {
                $auth.authUser(this, access_token, (response) => {
                    if (response.status) {
                        Event.$emit('userAuthorized');

                        let redirectUrl = localStorage.getItem('redirectUrl');

                        localStorage.removeItem('redirectUrl');

                        if (redirectUrl) {
                            this.$router.push({
                                path: redirectUrl
                            });
                        } else {
                            this.$router.push({ name: 'dashboard' });
                        }
                    } else {
                        console.log(response);
                    }
                });
            }
        }
    },

    mounted() {
        this.guard();

        Event.$on('userAuthorized', () => {
            methods.setDefaultBearer();
            this.user = $auth.getUser();
            localStorage.removeItem('communityId');
        });

        Event.$on('userLoggedOutAction', (route = null) => {
            $auth.logout();
            this.user = false;

            if (route.params.entity_id) {
                // We are gonna save the current entity id so
                // that the login screen can be customized.
                localStorage.setItem('communityId', route.params.entity_id);
            }

            // We are gonna save the current route so that
            // after login we can redirect user better.
            localStorage.setItem('redirectUrl', route.fullPath);

            this.$router.push({name: 'login'});
        });
    },

    created() {
        Event.$on('set_title', (title) => {
            document.title = title +" - "+ window.config.APP_NAME;
        });
    }
}
</script>

<style lang="sass">

</style>



// WEBPACK FOOTER //
// App.vue?170ceedc